import React from 'react';
import PropTypes from 'prop-types';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import ConnectionEditor from '../connectionEditor/ConnectionEditor';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

const initialState = {
  saveConnectionDisabled: true,
  checkingConnection: false,
  checkConnectionDisabled: true,
  connectionInformation: {
    id: '',
    label: '',
    description: '',
    userName: '',
    pswrd: '',
    port: '',
    address: '',
    sftpProfiles: [{
      profileId: '',
      directoryPath: '',
      fileKeyString: ''
    }]
  }
};

class ConnectionEditorContainer extends React.Component {
  state = { ...initialState, connectionInformation: { ...initialState.connectionInformation } };

  componentWillReceiveProps(nextProps) {
    if (this.props.creatingConnection && !nextProps.creatingConnection) {
      this.setState({ openConnectionEditorSlidingPanel: false });
    }
    if (this.props.fetchingConnection && !nextProps.fetchingConnection) {
      this.setState({
        openConnectionEditorSlidingPanel: true,
        connectionInformation: { ...nextProps.connection, pswrd: '***' },
        isCreation: false
      });
    }
    if (!this.state.isCreation && this.props.updatingConnection && !nextProps.updatingConnection) {
      this.setState({ openConnectionEditorSlidingPanel: false });
    }
  }

  handleCancelConfirmClick = () => {
    this.setState({ ...initialState, connectionInformation: { ...initialState.connectionInformation } });
  };

  handleSaveConnection = () => {
    if (this.props.isCreation) {
      this.props.connectionsActions.addConnection(this.state.connectionInformation);
    }
    else {
      this.props.connectionsActions.updateConnection(this.state.connectionInformation);
    }
    this.setState({ ...initialState, connectionInformation: { ...initialState.connectionInformation } });
    this.props.connectionsActions.clearFields();
    this.props.onCloseEditorSlidingPanel();
  };

  isSaveButtonDisabled = state => (
    state.label === '' ||
    state.userName === '' ||
    state.pswrd === '' ||
    state.port === '' ||
    state.address === '' ||
    (state.sftpProfiles.findIndex(profile => (profile.profileId === '' || profile.directoryPath === '')) !== -1)
  );

  isCheckButtonDisabled = state => (
    state.userName === '' ||
    state.pswrd === '' ||
    state.port === '' ||
    state.address === ''
  );

  handleFieldChange = (fieldName, value) => {
    this.setState(oldState => {
      const connectionInformation = { ...oldState.connectionInformation, [fieldName]: value };
      return ({
        connectionInformation,
        saveConnectionDisabled: this.isSaveButtonDisabled(connectionInformation),
        checkConnectionDisabled: this.isCheckButtonDisabled(connectionInformation)
      });
    });
  };

  handleProfileChange = (newSftpProfiles) => {
    this.setState(oldState => {
      const connectionInformation = { ...oldState.connectionInformation, sftpProfiles: [...newSftpProfiles] };
      return ({
        connectionInformation,
        saveConnectionDisabled: this.isSaveButtonDisabled(connectionInformation)
      });
    });
  };

  handleConfirmDialog = () => {
    this.props.onCloseEditorSlidingPanel();
    this.handleCancelConfirmClick();
    this.props.connectionsActions.clearFields();
  };

  handleCheckConnection = () => {
    this.props.connectionsActions.checkConnection(this.state.connectionInformation);
  };

  render() {
    const { openConnectionEditorSlidingPanel, isCreation, } = this.props;
    return (
      <div>
        <SovosEditableSlidingPanel
          title={ `${isCreation ? 'Create' : 'Update'} SFTP Import Connection` }
          isDirty={ () => true }
          open={ openConnectionEditorSlidingPanel }
          onClose={ this.handleConfirmDialog }
          showCloseButton={ false }
          baseWidth={ '1080px' }
          contentStyle={ { padding: 0 } }
          SaveButtonProps={ {
            onClick: this.handleSaveConnection,
            disabled: this.state.saveConnectionDisabled,
            className: 'connection-editor__button'
          } }
          CancelButtonProps={ {
            className: 'connection-editor__button',
            children: 'CANCEL'
          } }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
        >
          <ConnectionEditor
            connection={ this.state.connectionInformation }
            onChangeField={ this.handleFieldChange }
            OnCheckConnection={ this.handleCheckConnection }
            isCreation={ this.props.isCreation }
            checkingConnection={ this.props.checkingConnection }
            onProfileChange={ this.handleProfileChange }
            connectionResult={ this.props.connectionResult }
            checkDisabled={ this.state.checkConnectionDisabled }
          />
        </SovosEditableSlidingPanel>
      </div>
    );
  }
}

ConnectionEditorContainer.propTypes = {
  fetchingConnection: PropTypes.bool.isRequired,
  connection: PropTypes.object.isRequired,
  creatingConnection: PropTypes.bool.isRequired,
  updatingConnection: PropTypes.bool.isRequired,
  checkingConnection: PropTypes.bool.isRequired,
  connectionResult: PropTypes.string.isRequired,
  connectionsActions: PropTypes.shape({
    addConnection: PropTypes.func,
    updateConnection: PropTypes.func,
    checkConnection: PropTypes.func,
    clearFields: PropTypes.func
  }).isRequired,
  isCreation: PropTypes.bool.isRequired,
  openConnectionEditorSlidingPanel: PropTypes.bool.isRequired,
  onCloseEditorSlidingPanel: PropTypes.func.isRequired
};

export default ConnectionEditorContainer;



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionEditorContainer/ConnectionEditorContainer.js